import centerImage from "../../Images/(center-of-ksa)_AboutUs.png";
import BGimage from "../../Images/about-us2.png";

const AboutUsContent = () => {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${BGimage})`,
      }}
    >
      <div className="container mx-auto px-6 lg:px-8 pt-52 pb-16">
        {/* Main Content Section */}
        <div className="max-w-7xl mx-auto">
          {/* Company Title */}
          <div className="text-center mb-16">
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-8">
              Semars Holding
            </h1>
          </div>

          {/* Company Description */}
          <div className="max-w-5xl mx-auto mb-20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur md:col-span-3" data-aos="fade-right" data-aos-duration="800">
                <div className="mb-4 text-center">
                  <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                    Who We Are
                  </h3>
                </div>
                <p className="text-base lg:text-lg text-gray-200 leading-relaxed">
                  Founded in 2024, Semars Holding provides high-end business advisory, legal, and investment consulting services to international companies and investors seeking to enter or expand in Saudi Arabia. With over two decades of combined experience, our team has a deep understanding of the Kingdom’s evolving economic landscape and Vision 2030 transformation.
                </p>
              </div>

              {/* <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur" data-aos="fade-up" data-aos-duration="700" data-aos-delay="0">
                <div className="mb-4 text-center">
                  <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                    Vision
                  </h3>
                </div>
                <p className="text-base lg:text-lg text-gray-200 leading-relaxed">
                  To be Saudi Arabia’s most influential platform for enabling global investments, institutional partnerships, and economic transformation.
                </p>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                <div className="mb-4 text-center">
                  <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                    Mission
                  </h3>
                </div>
                <p className="text-base lg:text-lg text-gray-200 leading-relaxed">
                  To empower international clients with strategic guidance, regional insights, and operational excellence that drive enduring success in the Kingdom.
                </p>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                <div className="mb-4 text-center">
                  <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                    Goal
                  </h3>
                </div>
                <ul className="text-base lg:text-lg text-gray-200 leading-relaxed list-disc pl-6 space-y-2">
                  <li>To advance foreign direct investment in Vision 2030 sectors.</li>
                  <li>Strengthen Saudi-international trade corridors.</li>
                  <li>Facilitate sustainable innovation, localization, and knowledge exchange.</li>
                </ul>
              </div> */}
            </div>
          </div>

          {/* Founder’s Welcome Message */}
          <div className="max-w-5xl mx-auto mb-20" data-aos="fade-up" data-aos-duration="800">
            <div className="bg-white/5 border border-white/10 rounded-xl p-8 lg:p-10 backdrop-blur">
              <div className="text-center mb-4">
                <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                  Founder’s Welcome Message
                </h3>
              </div>
              <blockquote className="text-xl lg:text-2xl text-gray-100 italic text-center leading-relaxed">
                “Semars Holding was built to connect the world with the Kingdom’s incredible potential. With the right guidance and relationships, no market is out of reach. Our team is committed to making your business thrive in Saudi Arabia.”
              </blockquote>
              <p className="mt-4 text-center text-gray-300 text-base lg:text-lg">— Sabeel Sajid, Chairman & Founder</p>
            </div>
          </div>
          
          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mt-32">
            {/* Left Side - Image */}
            <div className="order-2 lg:order-1" data-aos="fade-right">
              <div className="relative">
                <div className="bg-gradient-to-br from-yellow-600/20 to-yellow-800/20 rounded-2xl p-4">
                  <img
                    src={centerImage}
                    alt="Saudi Arabia Industrial Development"
                    className="w-full h-auto rounded-xl object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="order-1 lg:order-2" data-aos="fade-left">
              <div className="space-y-8">
                <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                  We Are The Center Of KSA
                  <br />
                  To Offer You The Best
                </h2>

                <p className="text-gray-300 text-lg leading-relaxed">
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                  The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution of letters, as opposed to using 'Content
                  here, content here', making it look like readable English.
                  Many desktop publishing packages and web page editors now.
                </p>

                {/* Statistics Grid */}
                <div className="grid grid-cols-2 gap-6 pt-8">
                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#C99C48] mb-2">
                      20+
                    </div>
                    <div className="text-gray-400 text-sm uppercase tracking-wider">
                      Years
                      <br />
                      Experience
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#C99C48] mb-2">
                      100+
                    </div>
                    <div className="text-gray-400 text-sm uppercase tracking-wider">
                      Expert
                      <br />
                      Members
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#C99C48] mb-2">
                      15+
                    </div>
                    <div className="text-gray-400 text-sm uppercase tracking-wider">
                      Active
                      <br />
                      Countries
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#C99C48] mb-2">
                      10+
                    </div>
                    <div className="text-gray-400 text-sm uppercase tracking-wider">
                      Professional
                      <br />
                      Awards
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsContent;
